module.exports = "assets/cccfdf9d6c1be954ad0d2b3bc71f318a.glb";